/**
 * Shared helpers and badge components for Admin Panel
 */
import React from 'react';

// Use current origin for API calls to work in both preview and production
export const BACKEND_URL = window.location.origin;
export const API = `${window.location.origin}/api`;

// Status badge component
export const getStatusBadge = (status) => {
  const styles = {
    draft: 'bg-zinc-100 text-zinc-700',
    theme_selection: 'bg-blue-100 text-blue-700',
    design: 'bg-purple-100 text-purple-700',
    pending_review: 'bg-amber-100 text-amber-700',
    in_progress: 'bg-blue-100 text-blue-700',
    finalized: 'bg-green-100 text-green-700',
    rejected: 'bg-red-100 text-red-700'
  };
  const labels = {
    draft: 'Draft',
    theme_selection: 'Theme Selection',
    design: 'In Design',
    pending_review: 'Pending Review',
    in_progress: 'In Progress',
    finalized: 'Finalized',
    rejected: 'Rejected'
  };
  return (
    <span className={`px-2 py-0.5 rounded text-xs font-medium ${styles[status] || styles.draft}`}>
      {labels[status] || status}
    </span>
  );
};

// Plan badge component
export const getPlanBadge = (plan) => {
  if (!plan) return <span className="text-xs text-zinc-400">—</span>;
  const styles = {
    full_service: 'bg-emerald-100 text-emerald-700',
    diy_hosted: 'bg-blue-100 text-blue-700',
    diy_guidance: 'bg-purple-100 text-purple-700',
    save_only: 'bg-zinc-100 text-zinc-600'
  };
  const labels = {
    full_service: 'We Build It',
    diy_hosted: 'DIY Hosted',
    diy_guidance: 'DIY + Guidance',
    save_only: 'Save Only'
  };
  return (
    <span className={`px-2 py-0.5 rounded text-xs font-medium ${styles[plan] || 'bg-zinc-100 text-zinc-600'}`}>
      {labels[plan] || plan}
    </span>
  );
};

// Lead status badge
export const getLeadStatusBadge = (status) => {
  const styles = {
    new: 'bg-blue-100 text-blue-700',
    contacted: 'bg-amber-100 text-amber-700',
    converted: 'bg-green-100 text-green-700',
    lost: 'bg-red-100 text-red-700'
  };
  return (
    <span className={`px-2 py-0.5 rounded text-xs font-medium ${styles[status] || styles.new}`}>
      {status || 'new'}
    </span>
  );
};

// Team role badge
export const getRoleBadge = (role) => {
  const styles = {
    design_reviewer: 'bg-amber-100 text-amber-700',
    qa: 'bg-orange-100 text-orange-700',
    member: 'bg-zinc-100 text-zinc-600'
  };
  const labels = {
    design_reviewer: 'Design Reviewer',
    qa: 'QA Tester',
    member: 'Member'
  };
  return (
    <span className={`px-2 py-0.5 rounded text-xs font-medium ${styles[role] || styles.member}`}>
      {labels[role] || role}
    </span>
  );
};

// Stat card component
export const StatCard = ({ label, value, color, textColor, icon: Icon }) => (
  <div className={`border-l-4 ${color} bg-white rounded-lg shadow-sm`}>
    <div className="p-3">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-zinc-500 text-xs">{label}</p>
          <p className={`text-xl font-bold ${textColor}`}>{value}</p>
        </div>
        {Icon && <Icon className={`w-6 h-6 ${textColor} opacity-50`} />}
      </div>
    </div>
  </div>
);
